// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router/router'
import store from './store/store'
import VueSession from 'vue-session';
import axios from 'axios'
import 'expose-loader?$!expose-loader?jQuery!jquery'
import vSelect from 'vue-select'
import underscore from 'vue-underscore'
import vueNumeralFilterInstaller from 'vue-numeral-filter';
import jQuery from 'jquery'
window.jQuery = jQuery;
Vue.use(jQuery);

Vue.use(BootstrapVue);
Vue.use(VueSession);
Vue.use(underscore);
Vue.use(vueNumeralFilterInstaller);
Vue.component('v-select', vSelect);
// $ = jQuery;

import VueLogger from 'vuejs-logger';
const options = {
    isEnabled: true, // true , false
    logLevel : 'debug', // debug , error
    // logLevel : 'error', // debug , error
    // logLevel : 'debug', // debug , error
    stringifyArguments : false,
    showLogLevel : true,
    showMethodName : false,
    separator: '|',
    showConsoleColors: true
};
Vue.use(VueLogger, options);

// <script src="//cdn.ckeditor.com/4.6.2/full/ckeditor.js"></script>
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: {
    'App':App,
    // 'v-select': vSelect

  }
})



// WEBPACK FOOTER //
// ./src/main.js